import * as titleStyles from "../../styles/admissions/admissions.module.scss";

import React from "react";
import clsx from "clsx";
import {getDate} from "../../utils/parsing";

const Title = React.memo(function Title({
    label, subtitle, color, date, lang, id, infos
}) {
    let displayLang = "";
    if (lang) {
        displayLang = lang.toLowerCase();
    }

    const conditionalAttrLink = {}

    if (id) {
        conditionalAttrLink.id = id;
    }


    let parsedDate = getDate(date, ".");
    return (<div
        className={clsx(titleStyles.rootTitle, {
            [titleStyles.title_red]: color === "RED", [titleStyles.title_black]: color !== "RED"
        })}
        style={color === "RED" ? {backgroundColor: "var(--red-color)", color: "var(--white-color)"} : {backgroundColor: "var(--white-color)"}}
    >
        {date && (<div
            className={titleStyles.dateContent}
        >
            <p className={titleStyles.date}>
                {parsedDate}
            </p>
        </div>)}
        <div
            className={clsx(titleStyles.labelContent, titleStyles.espacementTitreBarre)}
        >
            {lang ? (<h1
                className={titleStyles.label}
                lang={displayLang}
                {...conditionalAttrLink}
            >
                {label}
            </h1>) : (<h1
                className={titleStyles.label}
                {...conditionalAttrLink}
            >
                {label}
            </h1>)}
        </div>
        {(label || subtitle) && (<div className={titleStyles.dividerContent}>
            <div className={titleStyles.dividerContentItem}>
                <div
                    className={clsx(titleStyles.espacementTitreBarre, titleStyles.horizontalBar)}
                    style={color === "RED" ? {backgroundColor: "var(--white-color)"} : {backgroundColor: "var(--red-color)"}}
                ></div>
            </div>
        </div>)}
        {subtitle && (<div className={titleStyles.subtitleContent}>
            {lang ? (<p
                className={titleStyles.subtitle}
                lang={displayLang}
            >
                {subtitle}
            </p>) : (<p
                className={titleStyles.subtitle}
            >
                {subtitle}
            </p>)}
        </div>)}
        {infos && <div className={titleStyles.infoContent}>
            {infos.map((info, index) => (
                <div key={index + "-infos"} className={titleStyles.infoDiv}>
                    {info}
                </div>
            ))}
        </div>}
    </div>);
});

export default Title;
